import { JsonNodeType, JsonNodeBasicType } from './config';
import { getNodeType, getBasicType, getNodeByPath, genValidPaths } from './jsonNode';

/* Json解析器
 * 作用：提供Response Body解析能力，用于body和字段解密
 * 参数：node节点值
 * 方法：modifyNodeByPath解密函数，修改节点信息
 */
export default class JsonParser {
  // 节点值
  private node;

  constructor(json) {
    this.node = json;
  }

  // 获取节点值
  get nodeVal() {
    return this.node;
  }

  // 节点转化为字符串类型
  private nodeToString() {
    if (!this.node) {
      return '';
    } else if (
      getBasicType(this.node) === JsonNodeBasicType.V_OBJECT ||
      getBasicType(this.node) === JsonNodeBasicType.V_ARRAY
    ) {
      return JSON.stringify(this.node);
    }
    return this.node.toString();
  }

  // 遍历field所有字段，修改节点（外部调用）
  async modifyNodeByPath(path: string, modFunc: (val: string) => Promise<string>) {
    const paths = genValidPaths(path);
    return await this.modifyNode(paths, modFunc);
  }

  // 递归修改节点
  private async modifyNode(paths: string[], modFunc: (val: string) => Promise<string>) {
    let travel;

    // eslint-disable-next-line prefer-const
    travel = async function (node, paths: string[]): Promise<string> {
      if (!node) {
        return '';
      }
      // 递归结束条件：paths数组为空
      if (paths.length === 0) {
        // 解密，修改节点值
        const res = await modFunc(node);
        return res;
      }
      const path = paths[0];
      const nodeType = getNodeType(node, path);
      // 根据节点类型，递归处理子节点
      switch (nodeType) {
        case JsonNodeType.JsonNodeType_Array:
          for (let i = 0; i < node.length; i++) {
            const res = await travel(node[i], paths.slice(1));
            node[i] = res;
          }
          return node;
        case JsonNodeType.JsonNodeType_Map:
          for (const key of Object.keys(node)) {
            const res = await travel(node[key], paths.slice(1));
            node[key] = res;
          }
          return node;
        case JsonNodeType.JsonNodeType_Object:
          const subNode = getNodeByPath(node, path);
          const res = await travel(subNode, paths.slice(1));
          node[path] = res;
          return node;
        case JsonNodeType.JsonNodeType_JsonString:
          const val = JSON.parse(node);
          const parser = new JsonParser(val);
          await parser.modifyNode(paths, modFunc);
          return parser.nodeToString();
        default:
          return node;
      }
    };
    this.node = await travel(this.node, paths);
    return this.node;
  }
}
